import apiClient from "./axios.config";

const homeService = {
  submitNewlyaddedForm() {
    return apiClient.get("/website/sub-category/newlyadded");
  },
  submitFeaturedForm() {
    return apiClient.get("/website/category/featured");
  },
  getAdsbanner() {
    return apiClient.get("/website/web-adbanner");
  },
};

export default homeService;
